/* eslint-disable react/prop-types */
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid, Typography, FormControlLabel, Checkbox } from '@mui/material';
import { TableContainer, Table, TableBody, TableRow, TableCell, CircularProgress } from '@mui/material';
import React, { Fragment, useEffect, useState, useCallback } from "react";
import { MultilineField, TextField } from 'style-guide';
import './Settings.scss';
import { useDispatch } from "react-redux";
import { snackbarToggle } from "reducers/snackbarSlicer";
import { REQUEST_ACTIONS, sendRequest } from 'utils/Communicator';

const Settings = ({ loginUser, updateLoginUser, onHandleCancelCustomerNotification, open = true }) => {
    const dispatch = useDispatch();
    const failedCallback = useCallback(message => {
        dispatch(snackbarToggle({ type: 'error', message }))
    }, [dispatch]);

    const [emailNotificationShipperAll, setEmailNotificationShipperAll1] = useState(false);
    const [emailNotificationShipper1, setEmailNotificationShipper1] = useState(false);
    const [emailNotificationShipper2, setEmailNotificationShipper2] = useState(false);
    const [emailNotificationShipper3, setEmailNotificationShipper3] = useState(false);
    const [emailNotificationShipper4, setEmailNotificationShipper4] = useState(false);
    const [emailNotificationShipper5, setEmailNotificationShipper5] = useState(false);
    const [emailNotificationShipper6, setEmailNotificationShipper6] = useState(false);
    const [emailNotificationShipper7, setEmailNotificationShipper7] = useState(false);
    const [emailNotificationShipper8, setEmailNotificationShipper8] = useState(false);
    const [emailNotificationTruckingAll, setEmailNotificationTruckingAll1] = useState(false);
    const [emailNotificationTrucking1, setEmailNotificationTrucking1] = useState(false);
    const [emailNotificationTrucking2, setEmailNotificationTrucking2] = useState(false);
    const [emailNotificationDEPAll, setEmailNotificationDEPAll1] = useState(false);
    const [emailNotificationDEP1, setEmailNotificationDEP1] = useState(false);
    const [emailNotificationDEP2, setEmailNotificationDEP2] = useState(false);
    const [emailNotificationDEP3, setEmailNotificationDEP3] = useState(false);
    const [emailNotificationDEP4, setEmailNotificationDEP4] = useState(false);
    const [emailNotificationCustoms1, setEmailNotificationCustoms1] = useState(false);
    const [emailNotificationDelivered1, setEmailNotificationDelivered1] = useState(false);
    const [notificationEmail, setNotificationEmail] = useState(false);

    const setEmailNotificationShipperAll = (data) => {
        setEmailNotificationShipperAll1(data);
        setEmailNotificationShipper1(data);
        setEmailNotificationShipper2(data);
        setEmailNotificationShipper3(data);
        setEmailNotificationShipper4(data);
        setEmailNotificationShipper5(data);
        setEmailNotificationShipper6(data);
        setEmailNotificationShipper7(data);
        setEmailNotificationShipper8(data);
    }
    const setEmailNotificationTruckingAll = (data) => {
        setEmailNotificationTruckingAll1(data);
        setEmailNotificationTrucking1(data);
        setEmailNotificationTrucking2(data);
    }
    const setEmailNotificationDEPAll = (data) => {
        setEmailNotificationDEPAll1(data);
        setEmailNotificationDEP1(data);
        setEmailNotificationDEP2(data);
        setEmailNotificationDEP3(data);
        setEmailNotificationDEP4(data);
    }

    const save = () => {
        var status = "" + emailNotificationShipper1 + "," + emailNotificationShipper2 + "," + emailNotificationShipper3 + "," + emailNotificationShipper4 + "," + emailNotificationShipper5 + "," + emailNotificationShipper6 + "," + emailNotificationShipper7 + "," + emailNotificationShipper8;
        status = status + "," + emailNotificationTrucking1 + "," + emailNotificationTrucking2;
        status = status + "," + emailNotificationDEP1 + "," + emailNotificationDEP2 + "," + emailNotificationDEP3 + "," + emailNotificationDEP4;
        status = status + "," + emailNotificationCustoms1;
        status = status + "," + emailNotificationDelivered1;
        sendRequest('/api/updateUserNotification/' + loginUser.id + '/' + status + "/" + notificationEmail, REQUEST_ACTIONS.PUT, '', {
            successCallback: response => {
                dispatch(snackbarToggle({ type: 'success', message: 'Notifications Saved!' }))
            },
            failedCallback,
        });
    }
    useEffect(() => {
        if (emailNotificationShipper1 && emailNotificationShipper2 && emailNotificationShipper3 && emailNotificationShipper4 && emailNotificationShipper5 && emailNotificationShipper6 && emailNotificationShipper7 && emailNotificationShipper8)
            setEmailNotificationShipperAll1(true);
        else
            setEmailNotificationShipperAll1(false);
    }, [emailNotificationShipper1,
        emailNotificationShipper2,
        emailNotificationShipper3,
        emailNotificationShipper4,
        emailNotificationShipper5,
        emailNotificationShipper6,
        emailNotificationShipper7,
        emailNotificationShipper8]);

    useEffect(() => {
        if (emailNotificationTrucking1 && emailNotificationTrucking2)
            setEmailNotificationTruckingAll1(true);
        else
            setEmailNotificationTruckingAll1(false);
    }, [emailNotificationTrucking1,
        emailNotificationTrucking2]);

    useEffect(() => {
        if (setEmailNotificationDEP1 && setEmailNotificationDEP2 && setEmailNotificationDEP3 && setEmailNotificationDEP4)
            setEmailNotificationDEPAll1(true);
        else
            setEmailNotificationDEPAll1(false);
    }, [setEmailNotificationDEP1,
        setEmailNotificationDEP2,
        setEmailNotificationDEP3,
        setEmailNotificationDEP4]);

    useEffect(() => {
        sendRequest('/api/user/' + loginUser.id, REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                if (response.notificationMail)
                    setNotificationEmail(response.notificationMail);
                if (!response.notifications) {
                    setEmailNotificationShipperAll(true);
                    setEmailNotificationTruckingAll(true);
                    setEmailNotificationDEPAll(true);
                    setEmailNotificationCustoms1(true);
                    setEmailNotificationDelivered1(true);
                    return;
                }
                var notifications = response.notifications?.split(",");
                if (notifications.length != 16) {
                    setEmailNotificationShipperAll(true);
                    setEmailNotificationTruckingAll(true);
                    setEmailNotificationDEPAll(true);
                    setEmailNotificationCustoms1(true);
                    setEmailNotificationDelivered1(true);
                } else {
                    setEmailNotificationShipper1(notifications[0] === "true" ? true : false);
                    setEmailNotificationShipper2(notifications[1] === "true" ? true : false);
                    setEmailNotificationShipper3(notifications[2] === "true" ? true : false);
                    setEmailNotificationShipper4(notifications[3] === "true" ? true : false);
                    setEmailNotificationShipper5(notifications[4] === "true" ? true : false);
                    setEmailNotificationShipper6(notifications[5] === "true" ? true : false);
                    setEmailNotificationShipper7(notifications[6] === "true" ? true : false);
                    setEmailNotificationShipper8(notifications[7] === "true" ? true : false);
                    setEmailNotificationTrucking1(notifications[8] === "true" ? true : false);
                    setEmailNotificationTrucking2(notifications[9] === "true" ? true : false);
                    setEmailNotificationDEP1(notifications[10] === "true" ? true : false);
                    setEmailNotificationDEP2(notifications[11] === "true" ? true : false);
                    setEmailNotificationDEP3(notifications[12] === "true" ? true : false);
                    setEmailNotificationDEP4(notifications[13] === "true" ? true : false);
                    setEmailNotificationCustoms1(notifications[14] === "true" ? true : false);
                    setEmailNotificationDelivered1(notifications[15] === "true" ? true : false);
                }
            },
            failedCallback,
        });
    }, []);
    

    return <Fragment>
        <Box className={`order-details ${open && 'open'}`} onClick={() => onHandleCancelCustomerNotification}>
            {loginUser && <Fragment>
                <Box className="detail-wrapper">
                    <Button className="close" onClick={onHandleCancelCustomerNotification}>
                        x
                    </Button>
                    <Grid item container className="settings-small-part">
                        <Button className="icon-btn-header" style={{}} onClick={() => { save() }}>
                            Save
                        </Button>
                        {/*<Button className="icon-btn-header" style={{}} onClick={() => { }}>
                            {`ניהול התראות`}
                        </Button>*/}
                    </Grid>
                    <Grid item container className="settings-big-part">
                        {/*<Grid item container className="settings-small-part" flexDirection="row-reverse">
                            <Button className="icon-btn-header" style={{}} onClick={() => { onHandleCancelCustomerNotification() }}>
                                Exit
                            </Button>
                        </Grid>*/}
                        <Grid item container>
                            <Grid item container>
                                <h1>{ `ניהול התראות`}</h1>
                            </Grid>
                            <Grid item container>
                                <h2 className="tk-good-times">Notification E-Mail</h2>
                            </Grid>
                            <Grid item container>
                                <Grid item container style={{ maxWidth: "300px", border: "1px solid grey", margin: "0 25px", padding: "10px" }} flexDirection="column">
                                    <TextField
                                        lg={11}
                                        label=''
                                        value={notificationEmail}
                                        onChange={event => setNotificationEmail(event.target.value)}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item container>
                                <h2 className="tk-good-times">Shipper</h2>
                            </Grid>
                            <Grid item container>
                                <Grid item container style={{ maxWidth: "300px", border: "1px solid grey", margin: "0 25px", padding: "10px" }} flexDirection="column">
                                    <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px", borderBottom:"1px solid grey" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationShipperAll} onChange={event => emailNotificationShipperAll ? setEmailNotificationShipperAll(false) : setEmailNotificationShipperAll(true)} />
                                            }
                                            label={"בחר הכל"}
                                        />
                                    </view>
                                    <view style={{ marginTop: "10px", marginLeft: "0", maxWidth: "500px" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationShipper1} onChange={event => emailNotificationShipper1 ? setEmailNotificationShipper1(false) : setEmailNotificationShipper1(true)} />
                                            }
                                            label={"בטיפול"}
                                        />
                                    </view>
                                    <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationShipper2} onChange={event => emailNotificationShipper2 ? setEmailNotificationShipper2(false) : setEmailNotificationShipper2(true)} />
                                            }
                                            label={"אין מענה"}
                                        />
                                    </view>
                                    <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationShipper3} onChange={event => emailNotificationShipper3 ? setEmailNotificationShipper3(false) : setEmailNotificationShipper3(true)} />
                                            }
                                            label={"המשלוח לא מוכן"}
                                        />
                                    </view>
                                    <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationShipper4} onChange={event => emailNotificationShipper4 ? setEmailNotificationShipper4(false) : setEmailNotificationShipper4(true)} />
                                            }
                                            label={"ממתין לתשלום"}
                                        />
                                    </view>
                                    <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationShipper5} onChange={event => emailNotificationShipper5 ? setEmailNotificationShipper5(false) : setEmailNotificationShipper5(true)} />
                                            }
                                            label={"צפי מוכנות"}
                                        />
                                    </view>
                                    <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationShipper6} onChange={event => emailNotificationShipper6 ? setEmailNotificationShipper6(false) : setEmailNotificationShipper6(true)} />
                                            }
                                            label={"ממתין לאיסוף"}
                                        />
                                    </view>
                                    <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationShipper7} onChange={event => emailNotificationShipper7 ? setEmailNotificationShipper7(false) : setEmailNotificationShipper7(true)} />
                                            }
                                            label={"ממתין  לבוקינג"}
                                        />
                                    </view>
                                    <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationShipper8} onChange={event => emailNotificationShipper8 ? setEmailNotificationShipper8(false) : setEmailNotificationShipper8(true)} />
                                            }
                                            label={"מוכן לאיסוף"}
                                        />
                                    </view>
                                </Grid>
                            </Grid>
                            <Grid item container>
                                <h2 className="tk-good-times">Trucking</h2>
                            </Grid>
                            <Grid item container>
                                <Grid item container style={{ maxWidth: "300px", border: "1px solid grey", margin: "0 25px", padding: "10px" }} flexDirection="column">
                                    <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px", borderBottom: "1px solid grey" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationTruckingAll} onChange={event => emailNotificationTruckingAll ? setEmailNotificationTruckingAll(false) : setEmailNotificationTruckingAll(true)} />
                                            }
                                            label={"בחר הכל"}
                                        />
                                    </view>
                                    <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationTrucking1} onChange={event => emailNotificationTrucking1 ? setEmailNotificationTrucking1(false) : setEmailNotificationTrucking1(true)} />
                                            }
                                            label={"איסוף תואם "}
                                        />
                                    </view>
                                    <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationTrucking2} onChange={event => emailNotificationTrucking2 ? setEmailNotificationTrucking2(false) : setEmailNotificationTrucking2(true)} />
                                            }
                                            label={"המטען נאסף"}
                                        />
                                    </view>
                                </Grid>
                            </Grid>
                            <Grid item container>
                                <h2 className="tk-good-times">Departure</h2>
                            </Grid>
                            <Grid item container>
                                <Grid item container style={{ maxWidth: "300px", border: "1px solid grey", margin: "0 25px", padding: "10px" }} flexDirection="column">
                                    <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px", borderBottom: "1px solid grey" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationDEPAll} onChange={event => emailNotificationDEPAll ? setEmailNotificationDEPAll(false) : setEmailNotificationDEPAll(true)} />
                                            }
                                            label={"בחר הכל"}
                                        />
                                    </view>
                                    <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationDEP1} onChange={event => emailNotificationDEP1 ? setEmailNotificationDEP1(false) : setEmailNotificationDEP1(true)} />
                                            }
                                            label={"צפי הגעה"}
                                        />
                                    </view>
                                    <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationDEP2} onChange={event => emailNotificationDEP2 ? setEmailNotificationDEP2(false) : setEmailNotificationDEP2(true)} />
                                            }
                                            label={"הגיע"}
                                        />
                                    </view>
                                    <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationDEP3} onChange={event => emailNotificationDEP3 ? setEmailNotificationDEP3(false) : setEmailNotificationDEP3(true)} />
                                            }
                                            label={"צפי יציאה"}
                                        />
                                    </view>
                                    <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationDEP4} onChange={event => emailNotificationDEP4 ? setEmailNotificationDEP4(false) : setEmailNotificationDEP4(true)} />
                                            }
                                            label={"הפליג / המריא"}
                                        />
                                    </view>
                                </Grid>
                            </Grid>
                            {/*<Grid item container>
                                <h2>Destination</h2>
                            </Grid>
                            <Grid item container>
                                <Grid item container style={{ border: "1px solid grey", margin: "25px", padding: "10px" }} flexDirection="column">
                                    <view style={{ marginTop: "10px", marginLeft: "0", maxWidth: "500px" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationShipper1} onChange={event => emailNotificationShipper1 ? setEmailNotificationShipper1(false) : setEmailNotificationShipper1(true)} />
                                            }
                                            label={"בטיפול"}
                                        />
                                    </view>
                                </Grid>
                            </Grid>*/}
                            <Grid item container>
                                <h2 className="tk-good-times">Customs</h2>
                            </Grid>
                            <Grid item container>
                                <Grid item container style={{ maxWidth: "300px", border: "1px solid grey", margin: "0 25px", padding: "10px" }} flexDirection="column">
                                    <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationCustoms1} onChange={event => emailNotificationCustoms1 ? setEmailNotificationCustoms1(false) : setEmailNotificationCustoms1(true)} />
                                            }
                                            label={"שוחרר"}
                                        />
                                    </view>
                                </Grid>
                            </Grid>
                            <Grid item container>
                                <h2 className="tk-good-times">Delivered</h2>
                            </Grid>
                            <Grid item container>
                                <Grid item container style={{ maxWidth: "300px", border: "1px solid grey", margin: "0 25px", padding: "10px" }} flexDirection="column">
                                    <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox checked={emailNotificationDelivered1} onChange={event => emailNotificationDelivered1 ? setEmailNotificationDelivered1(false) : setEmailNotificationDelivered1(true)} />
                                            }
                                            label={"נמסר"}
                                        />
                                    </view>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Fragment>}
        </Box>
    </Fragment>;
}

export default Settings;


